export default {
  'home.png': 'home.png',
  'invoice.png': 'invoice.png',
  'issue.png': 'issue.png',
  'setting.png': 'setting.png',
  'subsidy.svg': 'subsidy.svg',
  'tax.png': 'tax.png',
  'taxrefund.png': 'taxrefund.png',
}
